export default "__VITE_ASSET__bac76daf__"